// extracted by mini-css-extract-plugin
module.exports = {"topWinner":"LineItem__topWinner--2Xs","winAmount":"LineItem__winAmount--3CM","separator":"LineItem__separator--75T"};